module.exports = __webpack_public_path__ + "assets/f8e2c9f29d1af2e5347d2fd0ed9f1b66.png";